import { Box, Typography } from "@mui/material";


export const AccessDenied = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        width: "100%",
        minHeight: "400px",
        flexDirection: "column",
        gap: 2,
      }}
    >
      <Typography variant="h4" color="error">
        Access Denied
      </Typography>
      <Typography color="#6B7280">
        You do not have permission to view this page.
      </Typography>
    </Box>
  );
};

